import React from "react";

import {
  Check as CheckIcon,
  Close as CloseIcon,
  CloseRounded as CloseRoundedIcon,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

interface Props {
  open: boolean;
  onClose: () => void;
  status?: string | null | undefined;
  message: string;
  fullName: string;
}
const useStyles = makeStyles()((theme) => ({
  modalBody: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(24, 24),
    backgroundColor: colors.white,
    overflowY: "auto",
    width: "470px",
  },
  closeButton: {
    alignSelf: "flex-end",
  },
  content: {
    paddingBottom: theme.spacing(8),
  },
  header: {
    fontSize: "20px",
    fontWeight: 700,
    marginBottom: "12px",
  },
  message: {
    fontSize: "20px",
    fontWeight: 700,
    paddingBottom: "30px",
    textAlign: "center",
  },
  fullName: {
    color: "#ffad57",
  },
  status: {
    fontSize: "32px",
    fontWeight: 700,
  },
  iconContainer: {
    height: "66px",
    width: "66px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    marginBottom: "20px",
  },
  icon: {
    color: colors.white,
    fontSize: "50px",
  },
  schedule: {
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: "10px",
  },
  fullname: {
    fontSize: "16px",
    color: "#0B1B26",
    marginBottom: "10px",
    fontWeight: 700,
  },
}));

const FormConfirmationDialog: React.FC<Props> = ({
  open,
  onClose,
  status,
  message,
  fullName,
}) => {
  const { classes } = useStyles();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <IconButton
        className={classes.closeButton}
        onClick={onClose}
        size="large"
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className={classes.content}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Box
            className={classes.iconContainer}
            style={{
              backgroundColor: status == "success" ? "#26C9A7" : "#FF6262",
            }}
          >
            {status === "success" ? (
              <CheckIcon className={classes.icon} />
            ) : (
              <CloseRoundedIcon className={classes.icon} />
            )}
          </Box>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography className={classes.status}>
            {status == "success" ? "Successful" : ""}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography className={classes.message}>
            {message}
            <span className={classes.fullName}>{fullName}</span>
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Button color="primary" type="submit" onClick={onClose}>
            OK
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FormConfirmationDialog;
